/**
 * Created by zhaoyue on 2020/7/21 2:46 下午
 * 与app交互的bridge
 * 需要先引入dsBridge.js文件
 */
import dsBridge from "dsbridge";

/**
 * app中是否有dsBridge的注册事件
 * @param funName
 */
export function isHaveNativeMethod(funName: string) {
  return Boolean(dsBridge.hasNativeMethod(funName));
}

//app关闭webView
export function closeWebView() {
  if (isHaveNativeMethod("closed")) {
    dsBridge.call("closed");
  }
}

//app回到首页(原toHomeRefreshFuction 方法合并到此方法)
export function toHomeFuction() {
  if (isHaveNativeMethod("toHomeFuction")) {
    dsBridge.call("toHomeFuction");
  }
}

/**
 * vue 完成加载时调用此方法
 */
export function vueRouterDidFinishLoad() {
  if (isHaveNativeMethod("vueRouterDidFinishLoad")) {
    dsBridge.call("vueRouterDidFinishLoad");
  }
}

/**
 * 唤起登录页面
 * @param callback 关闭登录页面回调方法名string
 */
export function showLoginView(callback?: Function) {
  if (isHaveNativeMethod("showLoginView")) {
    console.log("调用showLoginViewBridge");
    dsBridge.call("showLoginView", callback);
  }
}

/**
 * 网页导航栏添加右边的 icon
 * @param iconUrl
 * @param callback
 */
export function addRightIcon(iconUrl: string, callback: any) {
  if (isHaveNativeMethod("addRightIcon")) {
    dsBridge.call("addRightIcon", { itemImage: iconUrl }, callback);
  }
}

/**
 * 网页导航栏移除右边的icon
 */
export function removeRightIcon() {
  if (isHaveNativeMethod("removeRightIcon")) {
    dsBridge.call("removeRightIcon");
  }
}

/**
 * 增加右上角文字跳转
 * @param {*} text //文字
 * @param {*} url //跳转链接
 * @param {*} textColor //536版本增加参数，文字颜色
 */
export function addHeadRightText(text: string, url: string, textColor: string) {
  if (!text || !url) {
    console.error("增加右上角文字跳转", text, url);
    return;
  }
  const params = {
    itemName: text,
    url,
    textColor
  };
  if (!textColor) {
    delete params.textColor;
  }
  if (isHaveNativeMethod("addRightText")) {
    dsBridge.call("addRightText", params);
  }
}

//移除右上角文字跳转
export function removeHeadRightText() {
  if (isHaveNativeMethod("removeRightText")) {
    dsBridge.call("removeRightText");
  }
}
